'use strict';

export default angular
  .module('maestro.services.offline', [])
  .service('OfflineService', OfflineService)
  .name;

function OfflineService(webcore, $timeout, $log) {

  angular.extend(this, {
    isConnected: isConnected,
    isDisconnected: isDisconnected,
    waitOnline: waitOnline,
    onDisconnected: onDisconnected,
    onConnected: onConnected
  });

  init();

  function init() {

  }

  function isConnected() {
    return !webcore.services.offline.offline;
  }

  function isDisconnected() {
    return !!webcore.services.offline.offline;
  }

  /**
   * Wait until server will be online
   * @returns {Promise<void>}
   */
  function waitOnline() {
    return webcore.services.offline.waitOnline();
  }

  /**
   * Subscribe of User Idle event
   * @param {function} cb callback
   * @return {function} unsubscribe function
   */
  function onDisconnected(cb) {
    return webcore.services.offline.onDisconnected.on(() => {
      try {
        cb(); // todo digest
      } catch (e) {
        $log.warn('[IdleService] Unable to run onDisconnected callback');
        $log.warn(e);
      }
    });
  }

  /**
   * Subscribe of User Active event
   * @param {function} cb callback
   * @return {function} unsubscribe function
   */
  function onConnected(cb) {
    return webcore.services.offline.onConnected.on(() => {
      try {
        cb(); // todo digest
      } catch (e) {
        $log.warn('[IdleService] Unable to run onConnected callback');
        $log.warn(e);
      }
    });
  }


}
